export default Object.freeze({
  info: {},
});
